var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.333 1.185L6.003 0h3.995l.669 1.185L8 4.457 5.333 1.185zm2.238 4.486L8 6.25l.43-.578 1.703 8.615L8 16l-2.133-1.714L7.57 5.67zM16 3.403h-4.543L9.6 5.233l1.22 3.877 2.812-1.13-1.75-2.316s3.814.238 4.118-2.261zm-16 0h4.543L6.4 5.233 5.18 9.11 2.368 7.98l1.75-2.316S.305 5.902 0 3.403z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/_/ugg/shared/assets/svg/roles/alt-3/supp.svg";
export { SvgSupp as ReactComponent };